// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"5015":"b0294848","8786":"e4de1148"}[chunkId] + ".css";
};